import { render, staticRenderFns } from "./chunk.vue?vue&type=template&id=bd1ba6b2"
import script from "./chunk.vue?vue&type=script&lang=js"
export * from "./chunk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports